import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  EntityType,
  ResponseMessageStatus,
  ResponseStatus,
  SortBy,
} from 'src/app/shared/enums';
import { BadeLoftService } from '../bade-loft.service';

@Component({
  selector: 'app-assignment',
  templateUrl: './assignment.component.html',
  styleUrls: ['./assignment.component.css'],
})
export class AssignmentComponent implements OnInit {
  //#region properties
  lst_Assignment: any = [];
  isVisible: boolean = false;
  editAssignmentDetail: any = null;
  sortField: string = 'createddate';
  sortBy: number = SortBy.Dsc || 1;
  page: number = 1;
  pageSize: number = 100;
  totalRecord: number = 0;
  searchText: string = '';
  oldSearchText: string = '';
  timer: any = null;
  isAssignmentListLoaded: boolean = false;
  isAssignmentPartsLoaded: boolean = false;
  isAuditVisible: boolean = false;
  entityDetails: any;
  entityType: number = EntityType.Assignment;
  assignMaxPageSize: number = 0;
  assignList_Request: any;
  //#endregion

  //#region functions
  onQueryParamsChange(event: any) {
    this.pageSize = this.pageSize;
    this.page = event;
    this.getAssignmentList();
  }

  getAssignmentList() {
    this.isAssignmentListLoaded = true;
    this._cdref.detectChanges();
    try {
      this.assignList_Request = this._blS
        .GetAssignments(
          this.searchText.trim(),
          this.sortField,
          this.sortBy,
          this.page,
          this.pageSize,
          false
        )
        .subscribe((res) => {
          if (res) {
            if (res.responseStatus == ResponseStatus.Success) {
              // this.lst_Assignment = [];
              var data = res.result.records;
              this.totalRecord = res.result.totalRecord;
              this.assignMaxPageSize = res.result.totalPage;
              if (data && data.length > 0) {
                data.forEach((x: any) => {
                  this.lst_Assignment.push(x);
                });
              }
              this.lst_Assignment.map((x: any) => {
                x.expand = false;
              });
              var urlInvoiceNumber: any;
              this.activatedRoute.queryParams.subscribe((params) => {
                urlInvoiceNumber = params['invoiceNumber'];
              });
              if (urlInvoiceNumber) {
                this._blS
                  .GetAssignmentByInvoiceNumber(urlInvoiceNumber)
                  .subscribe(
                    (res) => {
                      if (res) {
                        this.editAssignmentDetail = res.result.assignment;
                        this.isVisible = true;
                      } else {
                        const queryParams: Params = {};
                        this._router.navigate([], {
                          queryParams: queryParams,
                          queryParamsHandling: '', // remove to replace all query params by provided
                        });
                      }
                    },
                    (err: any) => {
                      const queryParams: Params = {};
                      this._router.navigate([], {
                        queryParams: queryParams,
                        queryParamsHandling: '', // remove to replace all query params by provided
                      });
                    }
                  );
              }
            } else {
              this.lst_Assignment = [];
              this._cS.displayMessage(ResponseMessageStatus.error, res.message);
            }
            var local_data = {
              searchText: this.searchText,
              sortBy: this.sortBy,
              sortField: this.sortField,
            };
            this._cS.setLocalStorageItem(
              'assignment_data',
              JSON.stringify(local_data)
            );
          }
          this.isAssignmentListLoaded = false;
        });
    } catch (error) {}
  }

  onExpandChange(i: number, checked: boolean, data: object, id: any): void {
    this.isAssignmentPartsLoaded = true;
    this.lst_Assignment[i].expand = checked;
    this._blS.GetAssignmentStock(id).subscribe((res) => {
      this.lst_Assignment[i].stocks = res.result;
      this.isAssignmentPartsLoaded = false;
    });
    this.isExpandAll =
      this.lst_Assignment.findIndex((x: any) => x.expand == true) > -1
        ? false
        : true;
    // if (this.isExpandAll) {
    //   this.lst_Assignment.map(function (x: any) {
    //     if (x != data) {
    //       x.expand = false;
    //     }
    //   });
    // }
  }

  removePartNumber(p: any, data: any, i: number, pi: number) {
    if (!data.qB_BL_Status || data.qB_BL_Status.toLowerCase() != 'shipped') {
      var assigIndex = this.lst_Assignment.findIndex(
        (x: any) => x.id == data.id
      );
      if (
        assigIndex > -1 &&
        this.lst_Assignment[assigIndex].stocks.length == 1
      ) {
        this._cS.displayMessage(
          ResponseMessageStatus.info,
          'At least one part number of stock should be needed for assignment.'
        );
      } else if (assigIndex > -1) {
        this._blS
          .DeleteAssignmentPartNumber(p.assignmentId, p.stockId, p.partNumber)
          .subscribe((res) => {
            if (res) {
              if (res.responseStatus == ResponseStatus.Success && res.result) {
                this._cS.displayMessage(
                  ResponseMessageStatus.success,
                  res.message
                );
                this.lst_Assignment[i].stocks.splice(pi, 1);
                this.lst_Assignment[assigIndex].stocks = [
                  ...this.lst_Assignment[assigIndex].stocks,
                ];
                if (this.lst_Assignment[assigIndex].stocks.length == 0) {
                  // this.lst_Assignment[assigIndex].stocks[i].splice(
                  //   assigIndex,
                  //   1
                  // );
                }
              } else {
                this._cS.displayMessage(
                  ResponseMessageStatus.error,
                  res.message
                );
              }
            }
          });
      }
    }
  }

  deleteSpecificPartNumber(p: any, data: any, i: number, pi: number) {}

  showAddUpdateAssignment() {
    this.isVisible = true;
  }

  editAssignment(data: any) {
    if (
      !data.qB_BL_Status ||
      data.qB_BL_Status.toString().toLowerCase() != 'shipped'
    ) {
      this.editAssignmentDetail = data;
      this.isVisible = true;
    }
  }

  deleteAssignment(data: any, i: number) {
    this._blS.DeleteAssignment(data.id).subscribe((res) => {
      if (res) {
        if (res.responseStatus == ResponseStatus.Success) {
          this._cS.displayMessage(ResponseMessageStatus.success, res.message);
          // if (this.lst_Assignment.length > 1) {
          this.lst_Assignment.splice(i, 1);
          this.lst_Assignment = [...this.lst_Assignment];
          // }
          // else {
          //   this.page = this.page > 1 ? this.page - 1 : this.page;
          //   this.getAssignmentList();
          // }
        } else {
          this._cS.displayMessage(ResponseMessageStatus.error, res.message);
        }
      }
    });
  }

  hideModal(event: any) {
    if (event.hide) {
      this.isVisible = !event.hide;
      if (this.editAssignmentDetail)
        this.editAssignmentDetail.stocks =
          this.editAssignmentDetail.stocks &&
          this.editAssignmentDetail.stocks.length > 0
            ? this.editAssignmentDetail.stocks
            : [];
      if (event.data && !this.editAssignmentDetail) {
        //   this.getAssignmentList();
        event.data.expand = false;
        this.lst_Assignment.unshift(event.data);
      } else if (event.data) {
        //  this.getAssignmentList();
        event.data.expand = false;
        var editIndex = this.lst_Assignment.findIndex(
          (x: any) => x.id == event.data.id
        );
        this.lst_Assignment[editIndex] = event.data;
      }
      this.editAssignmentDetail = null;
      this.lst_Assignment = [...this.lst_Assignment];
    }
  }

  onSearch(event: any) {
    if (event) {
      if (event.which != 9 && event.which != 18 && event.which != 27) {
        clearTimeout(this.timer);
        if (this.searchText.trim().length >= 3) {
          this.timer = setTimeout(() => {
            this.page = 1;
            this.lst_Assignment = [];
            if (this.assignList_Request) this.assignList_Request.unsubscribe();
            this.getAssignmentList();
          }, 1000);
        } else {
          if (this.searchText == '') {
            this.oldSearchText = '';
            this.page = 1;
            this.lst_Assignment = [];
            if (this.assignList_Request) this.assignList_Request.unsubscribe();
            this.getAssignmentList();
          }
        }
      }
    }
  }
  sort(key: string) {
    if (key) {
      this.sortBy = this.sortBy == SortBy.Asc ? SortBy.Dsc : SortBy.Asc;
      this.sortField = key;
      this.page = 1;
      this.lst_Assignment = [];
      if (this.assignList_Request) this.assignList_Request.unsubscribe();
      this.getAssignmentList();
    }
  }

  showHistoryModal(data: any) {
    this.isAuditVisible = true;
    this.entityDetails = data;
  }

  hideAuditModal(event: any) {
    this.isAuditVisible = !event.hide;
  }

  onScrollDown() {
    if (this.page != this.assignMaxPageSize) {
      this.page += 1;
      this.getAssignmentList();
    }
  }

  isAscPart: boolean = true;
  sortPart(isAsc: any, data: any) {
    this.isAscPart = isAsc;
    var ar = data.sort(function (a: any, b: any) {
      var nA = isAsc ? a.partNumber.toLowerCase() : b.partNumber.toLowerCase();
      var nB = isAsc ? b.partNumber.toLowerCase() : a.partNumber.toLowerCase();

      if (nA < nB) return -1;
      else if (nA > nB) return 1;
      return 0;
    });
    data = ar;
  }

  isExpandAll: boolean = true;
  expandAll() {
    var assignmentIds = this.lst_Assignment.map((a: any) => a.id);
    var body = [assignmentIds.join(',')];
    this._blS.ExpandAllPartnumber(body).subscribe((res) => {
      if (res) {
        if (
          res.responseStatus == ResponseStatus.Success &&
          res.result.records
        ) {
          this.isExpandAll = !this.isExpandAll;
          var data = res.result.records;
          this.lst_Assignment.map((x: any) => {
            x.expand = !this.isExpandAll ? true : false;
            x['stocks'] = [];
            data.forEach((ele: any) => {
              if (x.id == ele.assignmentId) {
                x['stocks']?.push(ele);
              }
            });
          });
        } else {
          this._cS.displayMessage(ResponseMessageStatus.error, res.message);
        }
      }
    });
  }
  //#endregion

  constructor(
    private _cdref: ChangeDetectorRef,
    private _blS: BadeLoftService,
    public _cS: CommonService,
    private activatedRoute: ActivatedRoute,
    private _router: Router
  ) {}

  ngOnInit(): void {
    var preReservedData: any = null;
    // preReservedData = this._cS.getLocalStorageItem('assignment_data');
    if (preReservedData) {
      preReservedData = JSON.parse(preReservedData);
      // this.page = preReservedData.page;
      // this.pageSize = preReservedData.pageSize;
      this.searchText = preReservedData.searchText;
      this.sortBy = preReservedData.sortBy;
      this.sortField = preReservedData.sortField;
    }
    // setTimeout(() => {
    // }, 100);
  }

  ngAfterViewInit(): void {
    this.getAssignmentList();
  }

  ngOnDestroy(): void {
    // var local_data = { page: this.page, pageSize: this.pageSize, searchText: this.searchText, sortBy: this.sortBy, sortField: this.sortField };
    // this._cS.setLocalStorageItem('assignment_data', JSON.stringify(local_data));
  }
}
